<template>
  <div>
    <h3 v-if="title" class="px-6 mb-6">{{ title }}</h3>
    <div>
      <div class="pb-8">
        <h3 class="mx-6 mb-6">{{ trans('dashboard.applications.title') }}</h3>
        <div class="grid-5 mx-6 mb-8">
          <div v-if="loadingYourApplications" class="inner-box mx-12 my-12">
            <loader class="text-60"/>
          </div>
          <template v-else>
            <application-card
              v-for="app in yourApplications"
              :key="`appcard-${app.id}`"
              class="inner-box overflow-hidden tile tile_app"
              :logo="getApplicationLogo(app)"
              :user="user"
              :app="app"
              @deleted-your-app="handleDeletedYourApp"
            />
          </template>
        </div>
      </div>
      <div>
        <div class="flex mb-6 align-center">
          <h3 class="mx-6">APIcenter appstore</h3>
          <div>
            <search-field @search-changed="handleSearch"/>
          </div>
        </div>
        <div class="grid-5 mx-6 mb-6">
          <div v-if="loadingNewApplications" class="inner-box mx-12 my-12">
            <loader class="text-60"/>
          </div>
          <template v-else>
            <div
              v-for="app in applications"
              :key="app.id"
              class="inner-box overflow-hidden tile tile_app"
              @click="handleAddApplication(app)"
            >
              <div class="px-6 pt-4 pb-2 gap-4 text-center">
                {{ app.name }}
              </div>
              <div class="px-6 pt-4 pb-2 gap-4 my-1 text-center">
                <img :alt="app.name" :src="getApplicationLogo(app)" height="90" width="90"/>
              </div>
            </div>
          </template>
        </div>
        <div class="mx-6">
          <pagination v-if="pagination" :pagination="pagination" @paginate="onPageChange"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Shared/Loader';
import ApplicationCard from '@/components/Dashboard/Application/Card';
import SearchField from '@/components/Dashboard/SearchField';
import Pagination from '@/components/Shared/Pagination';

export default {
  name: 'ListApplications',

  components: {
    Loader,
    ApplicationCard,
    SearchField,
    Pagination,
  },

  props: {
    user: Object,

    isFromWizard: {
      type: Boolean,
      default: false,
    },

    title: {
      type: [Boolean, String],
      default: false,
    },

    otherApplication: {
      type: [Object, null],
      default: null,
    },
  },

  data: () => ({
    applications: null,
    yourApplications: null,
    pagination: null,
    loadingNewApplications: true,
    loadingYourApplications: true,
    addedElements: [],
    showApplicationToolbar: false,
    search: '',
  }),

  mounted() {
    this.getApplications();
    this.getYourApplications();
  },

  watch: {
    filters() {
      this.getApplications();
      this.getYourApplications();
    },
  },

  computed: {
    filters() {
      const {page} = this.$route().params;

      const filters = {
        page: Number(page || '1'),
        search: this.search,
      };

      if (this.otherApplication != null) {
        filters.otherApplicationId = this.otherApplication.application_id;
      }

      return filters;
    },
  },

  methods: {
    handleSearch(search) {
      this.search = search;
      this.filters.page = 1;

      this.$inertia.reload({
        data: {
          page: 1,
        },
      });
    },

    getApplications() {
      this.loadingNewApplications = true;

      axios.get('/applications', {params: {id: this.user.id, ...this.filters}}).then(({data}) => {
        const {data: applications, ...rest} = data;
        this.pagination = rest;
        this.applications = applications;
        this.loadingNewApplications = false;
      });
    },

    getYourApplications() {
      this.loadingYourApplications = true;

      axios.get('/your-applications', {params: {id: this.user.id, ...this.filters}}).then(({data}) => {
        this.yourApplications = data.data;
        this.loadingYourApplications = false;
      });
    },

    getApplicationLogo(application) {
      let applicationInfo = application;

      if (application.application != null) {
        applicationInfo = application.application;
      }
      const logoFallback = `https://avatars.dicebear.com/api/identicon/${applicationInfo.name}.svg`;
      const logo = applicationInfo.logo_url;
      return logo ? logo : logoFallback;
    },

    handleAddApplication(app) {
      if (this.$can('applications.create')) {
        this.$emit('application-selected', app);
      }
    },

    onPageChange(data) {
      Object.assign(this.filters, data);

      const queryParams = {};
      Object.keys(this.filters).forEach(filter => {
        if (this.filters[filter] !== null) {
          queryParams[filter] = this.filters[filter];
        }
      });

      if (this.isFromWizard) {
        this.getApplications();

        return;
      }

      this.$inertia.visit(this.$route(this.$route().current(), {user: this.user.id}), {
        preserveScroll: true,
        data: queryParams,
      });
    },

    toggleApplicationToolbar() {
      this.showApplicationToolbar = !this.showApplicationToolbar;
    },

    handleDeletedYourApp() {
      this.getYourApplications();
    },
  },
};
</script>

<style scoped lang="scss">
.application {
  &_tool {
    display: flex;
    gap: 8px;
    align-items: center;

    svg {
      --length: 1rem;
      height: var(--length);
      widows: var(--length);
    }

    &bar {
      max-width: 5rem;
      position: absolute;
      z-index: 1;
      right: 1rem;
      top: 2rem;
      background: var(--light);
      padding: 1rem;

      &:not(.active) {
        display: none;
      }

      &_toggle {
        height: 2rem;
        width: 1rem;
        position: absolute;
        right: 1rem;
        top: 0.5rem;
      }
    }
  }
}

.tile {
  &_app {
    cursor: pointer;
    box-shadow: none;
  }
}
</style>
